import React, { ChangeEvent } from "react";
import { DateObject } from "../../../domain/fundamental/DateObject";

// **** 注意 ****
// <input type="date"/>を利用しているのでIE11では動かない。
// 管理機能でのみ使うのでこれでよしとしている。ユーザー向け画面では決して使わないこと。

export function AdminDatePicker(props: AdminDatePickerProps) {
    const { currentDate, whenDateChanged } = props;

    const handleChanged = (e: ChangeEvent<HTMLDataElement>) => {
        const value = e.target.value;
        whenDateChanged(value? DateObject.fromString(value) : null);
    };

    return (
        <div className={"admin_date_picker"}>
            <input type={"date"} value={currentDate?.format()} onChange={handleChanged}/>
        </div>
    );
}

export type AdminDatePickerProps = {
    currentDate: DateObject | null,
    whenDateChanged: (input: DateObject | null) => void,
};
